__turbopack_context__.v({
  "cardList": "cardList-module-scss-module__XogcRa__cardList",
  "grid": "cardList-module-scss-module__XogcRa__grid",
  "gridItem100": "cardList-module-scss-module__XogcRa__gridItem100",
  "gridItem50": "cardList-module-scss-module__XogcRa__gridItem50",
  "header": "cardList-module-scss-module__XogcRa__header",
  "headline": "cardList-module-scss-module__XogcRa__headline",
  "title": "cardList-module-scss-module__XogcRa__title",
});
